import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { GridState } from 'features/DataGrid/hooks/useGridState'
import { formatLocalDateUTC } from 'utils/date'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

const getItemNumber = (dataIndex: number, gridState: GridState) => {
  return dataIndex + (gridState.pageIndex - 1) * gridState.pageSize + 1
}

export const emailColumns = (gridState: GridState): GridColumn[] => [
  {
    title: '№',
    show: true,
    filter: 'text',
    cell: ({ dataIndex }: GridCellProps) => <td>{getItemNumber(dataIndex, gridState)}</td>,
    width: 50,
  },
  {
    title: 'Internal Name',
    field: 'name',
    show: true,
    filter: 'text',
    width: 400,
  },
  {
    title: 'ID',
    field: 'id',
    show: true,
    filter: 'text',
    width: 100,
  },
  {
    title: 'Subject',
    field: 'subject',
    show: true,
    filter: 'text',
    width: 500,
  },
  {
    title: 'Group',
    field: 'group',
    show: true,
    filter: 'text',
  },
  {
    title: 'Trigger',
    field: 'trigger',
    show: true,
    filter: 'text',
  },
  {
    title: 'Date Created',
    field: 'createdDate',
    cell: (gridCellProps: GridCellProps) => (
      <td className='table-columns__date'>
        {formatLocalDateUTC(gridCellProps.dataItem.createdDate, true)}
      </td>
    ),
    show: true,
    filter: 'text',
    width: 150,
  },
  {
    title: 'Last Updated',
    field: 'updatedDate',
    cell: (gridCellProps: GridCellProps) => (
      <td className='table-columns__date'>
        {formatLocalDateUTC(gridCellProps.dataItem.updatedDate, true)}
      </td>
    ),
    show: true,
    filter: 'text',
    width: 150,
  },
]
